// src/pages/health/components/WorkoutDeleteModal.js
import { useEffect } from "react";
import { XMarkIcon } from "@heroicons/react/24/solid";
import { format, parseISO, isValid } from "date-fns";

export default function WorkoutDeleteModal({
    open,
    workout,
    onClose,
    onDelete,
    isDeleting = false
}) {
    useEffect(() => {
        if (!open) return;
        const onKey = (e) => e.key === "Escape" && onClose?.();
        document.addEventListener("keydown", onKey);
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.removeEventListener("keydown", onKey);
            document.body.style.overflow = prev;
        };
    }, [open, onClose]);

    if (!open) return null;

    const rawDate = workout?.date ?? "";
    const d = parseISO(rawDate);
    const dateLabel = isValid(d) ? format(d, "yyyy-MM-dd") : rawDate;

    return (
        <div className="fixed inset-0 z-[200]" aria-modal="true" role="dialog">
            <div className="absolute inset-0 bg-black/40" onClick={onClose} />
            <div className="absolute left-1/2 top-1/2 w-[90vw] max-w-sm -translate-x-1/2 -translate-y-1/2">
                <div className="rounded-2xl bg-white shadow-lg overflow-hidden">
                    {/* 헤더 */}
                    <div className="flex items-center justify-center h-14 relative ">
                        <div className="font-semibold text-lg md:text-xl">운동 삭제</div>
                        <button
                            onClick={onClose}
                            className="absolute right-2 top-1/2 -translate-y-1/2 p-2 rounded-md hover:bg-gray-100"
                        >
                            <XMarkIcon className="w-7 h-7 text-gray-500" />
                        </button>

                    </div>

                    {/* 본문 */}
                    <div className="p-4 space-y-4">
                        <p className="text-center text-gray-700">다음 운동 내역을 삭제합니다.</p>

                        <div className="rounded-xl border border-gray-200 bg-gray-50 py-3 px-4 text-center leading-tight">
                            <div className="text-sm text-gray-500">{dateLabel}</div>
                            <div className="mt-0.5 font-semibold">{workout?.title ?? "운동"}</div>
                        </div>

                        {/* 버튼 */}
                        <div className="grid grid-cols-2 gap-2">
                            <button
                                type="button"
                                onClick={onClose}
                                disabled={isDeleting}
                                className="h-11 rounded-xl bg-gray-300 text-white font-semibold disabled:opacity-50"
                            >
                                취소
                            </button>
                            <button
                                type="button"
                                onClick={onDelete}
                                disabled={isDeleting}
                                className="h-11 rounded-xl bg-red-500 text-white font-semibold hover:bg-red-600 disabled:opacity-50"
                            >
                                삭제
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
